import React from 'react';
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

function HeaderTop({text}) {

  return (
    <React.Fragment>
      <div className="p-3 p-lg-4 border-bottom">
        <Row className="align-items-center">
          <Col sm={4} xs={8}>
            <div className="d-flex align-items-center">

              <div className="flex-grow-1 overflow-hidden">
                <h5 className="font-size-16 mb-0 text-truncate">
                  <Link to="#" className="text-reset user-profile-show">
                    {text}
                  </Link>
                </h5>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default HeaderTop;